import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCurlComponent } from './simple-icons-curl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCurlComponent ],
    exports:      [ SimpleIconsCurlComponent ],
    bootstrap:    []
})
export class SimpleIconsCurlModule {}
